import { FC} from "react";
import { CreateUserMolecule } from "../../../molecules";
interface ILogInPage {
  gameCount?: number
}

const LogInMolecule: FC<ILogInPage> = () => {

  return (
    <div className="login_molecule-wrapper">
      <CreateUserMolecule />
    </div>
  );
};

export default LogInMolecule;
